// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { secondaryMainNavigationStyles } from "@steiner/App/Widgets/Header/SecondaryMainNavigation";
import NavArrowDown from "@steiner/XDL/Icons/NavArrowDown";
import { color, layoutContainer, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

secondaryMainNavigationStyles.container = {
    css: css`
        position: relative;
        padding: 8px 0;

        display: flex;
        align-items: center;
        justify-content: space-around;

        &:not(.shell-editing) {
            background: ${color("common.ui6")};
            box-shadow: 0 0 0 100vmax ${color("common.ui6")};
            clip-path: inset(0 -100vmax);

            &:after {
                content: "";
                position: absolute;
                top: 0;
                bottom: 0;
                left: 50%;
                transform: translateX(-50%);
                width: 1px;
                height: 100%;
                background: ${color("common.white")};
            }
        }
    `,
};

secondaryMainNavigationStyles.shopNowLink = {
    color: "secondary",
    typographyProps: {
        size: 16,
        transform: "uppercase",
        css: css`
            line-height: 19px;
        `,
    },
    icon: {
        iconProps: {
            src: NavArrowDown,
            size: 12,
            color: "secondary",
        },
        position: "right",
    },
    css: css`
        justify-content: center;
    `,
};

secondaryMainNavigationStyles.reorderLink = {
    color: "common.white",
    typographyProps: {
        size: 16,
        transform: "uppercase",
        css: css`
            line-height: 19px;
        `,
    },
    css: css`
        justify-content: center;
    `,
};
